import apiClient from './client';

/** Sandbox-only admin API. Returns 403 in production. */
export const sandboxAPI = {
  info: () => apiClient.get('/admin/sandbox-info').then(r => r.data),

  reset: () =>
    apiClient.post('/admin/reset-sandbox', null, {
      params: { confirm: 'RESET-SANDBOX' },
      timeout: 120000, // seed can take up to 60s
    }).then(r => r.data),

  listMockEmails: (limit = 50) =>
    apiClient.get('/admin/mock-emails', { params: { limit } }).then(r => r.data),

  clearMockEmails: () =>
    apiClient.delete('/admin/mock-emails').then(r => r.data),
};

/** Quick env detection from /api/health (no auth needed). */
export async function detectEnvironment() {
  try {
    const r = await apiClient.get('/health');
    return r.data?.env || 'production';
  } catch {
    return 'production';
  }
}
